import axios from 'axios'
// import Vue from 'vue'

const instance = axios.create({
    // baseURL: Vue.prototype.baseURL,
    baseURL: '/api'
})
export default {
    registerUser(data) {
        // return instance.post(Vue.prototype.reqURL + "/user/registerin", data)
        return instance.post("/user/register", data)
    },
    loginUser(data) {
        // return instance.post(Vue.prototype.reqURL + "/user/login", data)
        return instance.post("/user/login", data)
    },
    // 拿到用户信息
    getInformation(data){
        return instance.post("/logSuccess/getInformation", data)
    },
    // 上传文件
    upload(data){
        return instance.post("/file/file", data)
    },
    //获取文件列表
    getFileList(){
        return instance.get("/list/getFileList")
    },
    //删除文件
    deleteFile(data){
        return instance.post("/file/delete",data)
    },
    //预览文件
    previewFile(data){
        return instance.post("/file/preview",data)
    },


    //毕业生信息录入
    graInformation(data){
        return instance.post("/information/graInformation",data)
    },
    //删除毕业生信息
    deleteGraInfor(data){
        return instance.post("/information/deleteGraInfor",data)
    },
    //获取毕业生信息列表
    getGraList(){
         return instance.get("/list/getGraList")
    },

    //更新毕业生信息
    updateInfor(data){
         return instance.post("/information/updateInfor",data)
    },

    //联合办学信息录入
    getUnionInformation(data){
        return instance.post("/information/unionInformation",data)
    },

    //删除联合办学信息
    deleteUnion(data){
        return instance.post("/information/deleteUnionInfor",data)
    },

    //获取联合办学信息列表
    getUnionList(){
        return instance.get("/list/getUnionList")
    },

    //更新联合办学信息
    updateUnion(data){
        return instance.post("/information/updateUnion",data)
    },

    // 测试
    helloTest() {
        // return instance.get(Vue.prototype.reqURL + "/user/hello")
        return instance.get("/user/hello")
    },

    authPost(data, config){
        return instance.post("/auth", data, config)
    }, 
    authGet(url){
        return instance.get(url)
    }
    
}